// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SortLabel--moderator":"fp_a bhu_hm","SortLabel__newFeature":"fp_b bhu_uc bhu_ur"};